<template>
  <div>
    <van-uploader v-model="files" multiple :before-read="beforeRead" :after-read="afterRead" :deletable="true"
      :delete="deletefile" accept="all">
      <!--     <van-button icon="photo"  type="primary">上传文件</van-button> -->
    </van-uploader>
  </div>
</template>

<script>
import {
  Toast
} from 'vant'
import {
  upload
} from '@/api/common.js'
export default {
  name: 'FileUpload',
  props: {
    // 值
    value: [String, Object, Array],
    // 数量限制
    limit: {
      type: Number,
      default: 100
    },
    // 大小限制(MB)
    fileSize: {
      type: Number,
      default: 50
    },
    // 文件类型, 例如['png', 'jpg', 'jpeg']
    fileType: {
      type: Array,
      default: () => ['doc', 'xls', 'xlsx', 'ppt', 'txt', 'pdf', 'jpeg', 'jpg', 'png']
    },
    // 是否显示提示
    isShowTip: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      files: [],
      number: 0,
      uploadList: [],
      fileList: []
    }
  },
  watch: {
    value: {
      handler (val) {
        if (val) {
          let temp = 1
          // 首先将值转为数组
          const list = Array.isArray(val) ? val : this.value.split(',')
          // 然后将数组转为对象数组
          this.files = list.map(item => {
            if (typeof item === 'string') {
              item = {

                name: item,
                url: item
              }
            }
            item.uid = item.uid || new Date().getTime() + temp++
            return item
          })
        } else {
          this.files = []
          return []
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    beforeRead (ee) {
      const e = this.objToArr(ee)

      e.forEach(item => {
        if (item.size > this.fileSize * 1024 * 1024) {
          this.$toast.fail('文件大小不能超过' + this.fileSize + 'M')
          return false
        }
      })
      this.number = e.length
      return true

      // ... 文件读取前的验证逻辑
    },
    afterRead (filee) {
      const files = this.objToArr(filee)
      console.log('afterRead', this.files, files)
      // ... 文件读取完成后的回调 file可能是数组也可能是对象 稀烂
      this.files.map((item, index) => {
        if (!item.url) { this.fileUp(item.file, index) }
      })
    },
    deletefile (event) {
      console.log('delete', event, this.files)
    },
    objToArr (e) {
      if (e instanceof Array) return e
      else return [e]
    },
    listToString (list, separator) {
      let strs = ''
      separator = separator || ','
      for (let i in list) {
        strs += list[i].url + separator
      }
      return strs != '' ? strs.substr(0, strs.length - 1) : ''
    },
    tijiao () {
      console.log('tijiao', this.listToString(this.files))
      this.$emit('input', this.listToString(this.files))
    },
    async fileUp (file, index) {
      // 其他格式的文件
      const formData = new window.FormData()
      formData.append('file', file)
      // 计算现在所有图片的大小，如果加上该文件超过10M则不可上传

      const res = await upload(formData)
      console.log('upload', res)

      if (res.code === 200) {
        //	this.fileIds.push(res.fileId)
        this.files[index].status = 'done'
        this.files[index].message = '上传成功'
        this.files[index].url = res.url
        this.uploadList.push({ name: res.fileName, url: res.fileName })
        if (this.number == this.uploadList.length) {
          this.uploadList = []
          this.number = 0
          this.$toast.success('文件已上传')
          this.tijiao()
        }
      } else {
        this.$toast.fail('文件上传失败')
        if (index == undefined) {
          this.files[this.files.length - 1].status = 'failed'
          this.files[this.files.length - 1].message = '上传失败'
        } else {
          this.files[index].status = 'failed'
          this.files[index].message = '上传失败'
        }
      }
    }

  }
}
</script>



// WEBPACK FOOTER //
// src/components/uploadFile/index.vue